/**
 * The banner for the cold start that did not complete (SYN-2491).
 *
 * 🔴 WHY THIS EXISTS AT ALL. The defect being fixed was not "no organisation". It was that a
 * fresh sign-up landed on a screen reading "You're connected" while every request behind it
 * came back `403 Organization context required`. A silent failure is the defect, so the fix
 * is not done until a failure has somewhere to appear. This repo's CLAUDE.md is the standing
 * rule: plumbing without a UI surface is unfinished.
 *
 * Buyer language in the primary copy — the raw reason (`provisioning_failed: …`) goes behind
 * `TechnicalDetails`, which is the only sanctioned home for machine strings on a buyer
 * surface (SYN-1486) and is excluded from the vocabulary-leakage scan.
 */

import { AlertTriangle } from "lucide-react";
import { TechnicalDetails } from "./TechnicalDetails";
import { useOrgContext } from "../providers/OrgProvider";

export function OrgSetupBanner() {
  const { orgSetupError, retryOrgSetup } = useOrgContext();

  if (!orgSetupError) {
    return null;
  }

  return (
    <div className="border-b border-red-500/30 bg-red-500/10 px-6 py-2 text-sm text-red-700 dark:text-red-400">
      <div className="flex items-center justify-between gap-3">
        <div className="flex min-w-0 items-center gap-2">
          <AlertTriangle className="h-4 w-4 shrink-0" />
          <span className="min-w-0">
            We could not finish setting up your workspace, so nothing here will work yet. Try again,
            and if it keeps failing, contact support.
          </span>
        </div>
        <button
          type="button"
          onClick={() => void retryOrgSetup()}
          className="inline-flex shrink-0 items-center rounded-md border px-2 py-1 text-xs font-medium hover:bg-background/70"
        >
          Try again
        </button>
      </div>
      <TechnicalDetails className="mt-2" entries={[{ label: "Reason", value: orgSetupError }]} />
    </div>
  );
}
